export default __webpack_public_path__ + "static/media/ic-english-primary.c70da9ca.svg";